interface BrandLogoProps {
  className?: string;
  alt?: string;
  priority?: boolean;
}

const BRAND_LOGO_SRC = "/ONTOLIGENT.-logo-assetsv3/ONTOLIGENT.-transparent-2x.png";
const BRAND_MARK_SRC = "/ONTOLIGENT.-logo-assetsv3/logo-icon.png";

export function BrandLogo({
  className = "h-7 w-auto",
  alt = "Ontoligent",
  priority = false,
}: BrandLogoProps) {
  return (
    <img
      src={BRAND_LOGO_SRC}
      alt={alt}
      width={285}
      height={72}
      className={className}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : "auto"}
    />
  );
}

/**
 * Square brand mark (favicon) for tight spaces such as the collapsed sidebar,
 * where the full wide wordmark would be distorted.
 */
export function BrandMark({
  className = "h-6 w-6",
  alt = "Ontoligent",
  priority = false,
}: BrandLogoProps) {
  return (
    <img
      src={BRAND_MARK_SRC}
      alt={alt}
      width={512}
      height={512}
      className={`object-contain ${className}`}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : "auto"}
    />
  );
}
